export const WorkStationTypes = [
  "Shear",
  "Brake",
  "Slit Line",
  "Roll Former",
  "Bench",
  "Laser",
];
export const getWorkStationColor = (workStationType) => {
  let color = "#fff";
  switch (workStationType) {
    case "Shear":
      // color = "yellow";
      color = "#FBC901"; // Philippine Yellow https://www.schemecolor.com/dark-gold-box-color-scheme.php
      // color = "#FEDC01"; // Sizzling Sunrise https://www.schemecolor.com/new-yellow-and-blue.php
      // color = "#FFB302"; // UCLA Gold
      break;
    case "Brake":
      color = "red";
      break;
    case "Slit Line":
      color = "green";
      break;
    case "Roll Former":
      color = "orange";
      color = "#FB9C05"; // RYB Orange https://www.schemecolor.com/banana-orange.php
      break;
    case "Bench":
      // color = "blue";
      color = "#2162FE";
      break;
    case "Laser":
      color = "purple";
      break;
    default:
      color = "gray";
  }

  return color;
};
